"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENUMS = exports.classes = exports.LunaLoadingIndicatorSizes = exports.LunaLoadingIndicatorTypes = void 0;

var _sizes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaLoadingIndicatorTypes = {
  inline: 'inline'
};
exports.LunaLoadingIndicatorTypes = LunaLoadingIndicatorTypes;
var LunaLoadingIndicatorSizes = {
  size5: 'size5',
  size10: 'size10',
  size20: 'size20',
  size30: 'size30'
};
exports.LunaLoadingIndicatorSizes = LunaLoadingIndicatorSizes;
var __baseClass = 'luna-loading';
var classes = {
  base: __baseClass,
  types: _defineProperty({}, LunaLoadingIndicatorTypes.inline, "".concat(__baseClass, "-inline")),
  sizes: (_sizes = {}, _defineProperty(_sizes, LunaLoadingIndicatorSizes.size5, "".concat(__baseClass, "-size-5")), _defineProperty(_sizes, LunaLoadingIndicatorSizes.size10, "".concat(__baseClass, "-size-10")), _defineProperty(_sizes, LunaLoadingIndicatorSizes.size20, "".concat(__baseClass, "-size-20")), _defineProperty(_sizes, LunaLoadingIndicatorSizes.size30, "".concat(__baseClass, "-size-30")), _sizes)
};
exports.classes = classes;
var ENUMS = {
  LunaLoadingIndicatorTypes: LunaLoadingIndicatorTypes,
  LunaLoadingIndicatorSizes: LunaLoadingIndicatorSizes
};
exports.ENUMS = ENUMS;
